import React, { useState } from 'react';
import Card from '../../components/common/Card/Card';
import Modal from '../../components/common/Modal/Modal';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { CONCURSOS_DATA, formatConcursoDate } from '../../constants/concursosData';
import './Concursos.css';

const Concursos = () => {
    const [selectedCategory, setSelectedCategory] = useState('Todos');
    const [selectedConcurso, setSelectedConcurso] = useState(null);

    const categories = ['Todos', ...new Set(CONCURSOS_DATA.map(c => c.category))];
    const filteredConcursos = selectedCategory === 'Todos'
        ? CONCURSOS_DATA
        : CONCURSOS_DATA.filter(c => c.category === selectedCategory);

    return (
        <div className="concursos">
            <PageHeader
                title="Concursos y Olimpiadas"
                subtitle="Participa en nuestros concursos académicos, artísticos y deportivos. ¡Demuestra tu talento!"
            />

            <div className="container">
                <section className="concursos__filters animate-slide-up">
                    <div className="concursos__filter-buttons">
                        {categories.map(cat => (
                            <button
                                key={cat}
                                className={`concursos__filter-btn ${selectedCategory === cat ? 'concursos__filter-btn--active' : ''}`}
                                onClick={() => setSelectedCategory(cat)}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </section>

                <section className="concursos__list-section">
                    <div className="concursos__list">
                        {filteredConcursos.map((item, idx) => (
                            <Card
                                key={item.id}
                                hoverable
                                className={`animate-scale-in animate-delay-${Math.min(idx % 3 + 1, 4)}`}
                            >
                                <article className="concursos__item">
                                    <div className="concursos__item-image">
                                        <img
                                            src={item.image}
                                            alt={item.imageAlt || item.title}
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/400x300?text=Imagen+no+disponible';
                                            }}
                                        />
                                    </div>
                                    <div className="concursos__item-content">
                                        <span className="concursos__category">{item.category}</span>
                                        <h2 className="concursos__title">{item.title}</h2>
                                        <p className="concursos__date">📅 Fecha: {formatConcursoDate(item.startDate)}</p>
                                        <p className="concursos__deadline">⏰ Cierre: {formatConcursoDate(item.registrationDeadline)}</p>
                                        {item.organizer && <p className="concursos__organizer">👥 Organiza: {item.organizer}</p>}
                                        <p className="concursos__excerpt">{item.excerpt}</p>
                                        <button className="concursos__read-more" onClick={() => setSelectedConcurso(item)}>
                                            Ver más detalles →
                                        </button>
                                        {item.links && item.links.length > 0 && (
                                            <div className="concursos-modal__links">
                                                <h4 className="concursos-modal__links-title">🔗 Información útil</h4>
                                                <ul className="concursos-modal__links-list">
                                                    {item.links.map((link, i) => (
                                                        <li key={i}>
                                                            <a href={link.url} target="_blank" rel="noopener noreferrer" className="concursos-modal__link">
                                                                {link.label}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </article>
                            </Card>
                        ))}
                    </div>
                    {filteredConcursos.length === 0 && (
                        <div className="concursos__empty">
                            <p>No hay concursos en esta categoría.</p>
                        </div>
                    )}
                </section>
            </div>

            <Modal
                isOpen={!!selectedConcurso}
                onClose={() => setSelectedConcurso(null)}
                title={selectedConcurso?.title || ''}
                size="lg"
            >
                {selectedConcurso && (
                    <div className="concursos-modal">
                        <div className="concursos-modal__image">
                            <img
                                src={selectedConcurso.image}
                                alt={selectedConcurso.imageAlt || selectedConcurso.title}
                                onError={(e) => {
                                    e.target.src = 'https://via.placeholder.com/800x450?text=Imagen+no+disponible';
                                }}
                            />
                        </div>
                        <div className="concursos-modal__meta">
                            <span className="concursos-modal__category">{selectedConcurso.category}</span>
                            <span className="concursos-modal__date">📅 {formatConcursoDate(selectedConcurso.startDate)}</span>
                            <span className="concursos-modal__deadline">⏰ Cierre: {formatConcursoDate(selectedConcurso.registrationDeadline)}</span>
                            {selectedConcurso.organizer && (
                                <span className="concursos-modal__organizer">👥 {selectedConcurso.organizer}</span>
                            )}
                            {selectedConcurso.location && (
                                <span className="concursos-modal__location">📍 {selectedConcurso.location}</span>
                            )}
                            {selectedConcurso.prize && (
                                <span className="concursos-modal__organizer">🏆 {selectedConcurso.prize}</span>
                            )}
                        </div>
                        <div className="concursos-modal__content">
                            {selectedConcurso.content.split('\n').map((para, i) => para.trim() && <p key={i}>{para}</p>)}
                        </div>
                        {selectedConcurso.links && selectedConcurso.links.length > 0 && (
                            <div className="concursos-modal__links">
                                <h4 className="concursos-modal__links-title">🔗 Información útil</h4>
                                <ul className="concursos-modal__links-list">
                                    {selectedConcurso.links.map((link, i) => (
                                        <li key={i}>
                                            <a href={link.url} target="_blank" rel="noopener noreferrer" className="concursos-modal__link">
                                                {link.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default Concursos;